import * as Lexer from 'lex';

class Stack<T> {
   store:T[] = [];

   constructor(obj?:T) {
      if (obj) {
         this.push(obj);
      }
   }

   get empty() {
      return this.store.length == 0;
   }

   push(obj:T) {
      this.store.push(obj);
   }

   peek() {
      if (!this.empty) {
         return this.store[this.store.length - 1];
      } else {
         return null;
      }
   }

   pop() {
      return this.store.pop();
   }
}

export enum Statement {
   If,
   IfNot,
   ElseIf,
   Else
}

export class Conditional {
   blocks:Block[] = [];

   constructor(smt:Statement, exp:string) {
      this.addBlock(smt, exp);
   }

   addBlock(smt:Statement, exp?:string) {
      this.blocks.push(new Block(smt, exp));
   }

   append(s:string) {
      this.blocks[this.blocks.length - 1].buffer.push(s);
   }
}

class Block {
   smt:Statement;
   exp?:string;
   buffer:string[] = [];

   constructor(smt:Statement, exp?:string) {
      this.smt = smt;
      this.exp = exp;
   }

   toString() {
      return this.buffer.join('');
   }
}

interface TagHandler {
   (tag:string):string
}

interface ConditionalHandler {
   (cond:Conditional):string
}

/**
 * Pasrses mandrill/mailchimp merge vars.
 * https://mailchimp.com/help/use-conditional-merge-tag-blocks/
 * @param handleTag function to process merge tags (`*|TagName|*`)
 * @param handleCond funtion to process merge conditions (`*|IF:...|*`)
 * @param html input html
 * @returns processed html
 */
export function mergeParser(handleTag:TagHandler, handleCond:ConditionalHandler, html:string) {
   const buffer = [];
   const stack = new Stack<Conditional>();

   const lex = new Lexer((s:string) => {
      if (!stack.empty) {
         stack.peek().append(s);
      } else {
         buffer.push(s);
      }
   });

   lex.addRule(/\*\|([^|]+)\|\*/, (match, tag:string) => {
      if (tag.indexOf('IF:') == 0) {
         stack.push(new Conditional(Statement.If, tag.slice(3)));
      } else if (tag.indexOf('IFNOT:') == 0) {
         stack.push(new Conditional(Statement.IfNot, tag.slice(6)));
      } else if (tag.indexOf('ELSEIF:') == 0) {
         stack.peek().addBlock(Statement.ElseIf, tag.slice(7));
      } else if (tag.indexOf('ELSE:') == 0) {
         stack.peek().addBlock(Statement.Else);
      } else if (tag == 'END:IF') {
         let cond = stack.pop();
         writeOut(handleCond(cond));
      } else {
         writeOut(handleTag(tag));
      }
   });

   lex.input = html;
   lex.lex();

   return buffer.join('');

   function writeOut(s:string) {
      if (!stack.empty) {
         stack.peek().append(s);
      } else {
         buffer.push(s);
      }
   }
}
